import styled from 'styled-components'

const compTrans = (inverted: boolean, value: number) =>
  inverted ? `${value === 0 ? 0 : -100 * (10 - value)}%` : `${-100 * value}%`

export const DigitWrapper = styled.span<{
  value: number
  inverted: boolean
  invisible?: boolean
}>`
  display: inline-block;
  position: relative;
  height: 1.42em;
  margin: 0 0.2rem;
  padding: 0 0.24em;
  overflow: hidden;
  box-shadow: 1px -1px 4px 0px #00000040 inset;
  background: white linear-gradient(to top, #eee, white);

  span {
    display: block;
    margin: 0 -0.05em;
    text-align: center;
    transform: translateY(
      ${({ inverted, value }) => compTrans(inverted, value)}
    );
    transition: transform 1.5s, opacity 0.3s;
  }
`
